<template>
  <div class="SaveDraftContent">
    <h3 class="title" v-html="title"></h3>
    <div class="content" v-html="content"></div>
    <form @submit.prevent="onSubmit">
      <div class="formRow">
        <div class="inputField">
          <input class="textInput" placeholder="Indirizzo e-mail registrato" type="email" v-model="email" />
        </div>
        <div class="msg">
          <div class="error" v-if="$v.email.$dirty && !$v.email.required" >Campo obbligatorio</div>
          <div class="error" v-if="$v.email.$dirty && !$v.email.email" >Formato non valido</div>
          <div class="error" v-if="errorMessage" v-html="errorMessage"></div>
          <div class="ok" v-if="okMessage" v-html="okMessage"></div>
        </div>
      </div>
      <div class="btn">
        <input type="submit" :value="submitText">
      </div>
    </form>
  </div>
</template>

<script>
  import EventBus from '../views/event_bus';

  import { required, email } from 'vuelidate/lib/validators'

  export default {
    name: 'SaveDraftContent',
    data(){
      return {
        email: null,
        okMessage: null,
        errorMessage: null
      }
    },
    validations: {
      email: {
        required,
        email
      },
    },
    methods: {
      submit(){
        EventBus.$emit('save-draft', {
          email: this.email
        })
        EventBus.$once('draft-saved', this.onDraftSaved)
        EventBus.$once('draft-error', this.onDraftError)
      },

      onDraftSaved(){
        this.$el.querySelector('[type=submit]').removeAttribute('disabled');
        this.okMessage = "Bozza salvata con successo."
      },

      onDraftError(e){
        this.$el.querySelector('[type=submit]').removeAttribute('disabled');
        this.errorMessage = e.msg
      },

      onSubmit(e){
        var me = this
        me.$v.$touch();
        // me.$nextTick(() => me.focusFirstStatus());
        if(!me.$v.$invalid){
          this.$el.querySelector('[type=submit]').setAttribute('disabled', true);
          me.submit()
        }else{
          console.log('invalid data')
        }
      }
    },
    props: {
      title: {
        type: String,
        default: "Accedi alla bozza"
      },
      submitText: {
        type: String,
        default: "INVIA IL LINK VIA EMAIL E ACCEDI"
      },
      content: {
        type: String,
        default: "Per recuperare le informazioni salvate, inserisci la tua email. Ti arriverà un link per accedere a questa pagina nuovamente. Salvando la candidatura accetti la nostra <a href='https://bicocca-network.servercdn.it/media/Informativa_Bicocca_Universita_del_Crowdfunding_-_Folkfunding.pdf' target='_blank'>Privacy Policy</a>"
      },
      userEmail: {
        type: String,
        default: ""
      }
    },
    mounted(){
      this.email = this.userEmail
    }
  }
</script>

<style lang="less" scoped>
  @import (reference) '~@less/_variables';
  @import (reference) '~@less/_fonts';
  .title{
    .CB;
    margin: 0;
    font-size: 24px;
  }

  .content{
    margin: 20px 0 35px;
    font-size: 18px;
    line-height: 26px;
    a:link, a:visited, a:hover, a:active{
      color: var(--special-network-color);
    }
  }

  .formRow{
    margin-bottom: 25px;
  }

  .btn{
    a{ 
      display: block;
      padding: 12px 0; 
      text-align: center;
      &:link, &:visited, &:hover, &:active{
        text-decoration: none;
        background: var(--special-network-color);
        color: #fff;
        font-size: 15px;
        .CB;
        line-height: 26px;
      }
    }
    input{
      text-transform: uppercase
    }
  }

  .ok{
    color: #00a500;
  }

  .error{
    color: #ff0000
  }
</style>
